import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getAuthLoginEndpointUrl } from '@/config';

const AUTH_ME_PATH = '/api/clients-dmp/v1/auth/me';
const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

const baseQuery = fetchBaseQuery({ baseUrl: window.location.origin, credentials: 'include' });

const authApi = createApi({
    baseQuery: (args, api, extraOptions) => baseQuery(args, { ...api, signal: undefined }, extraOptions),
    endpoints: (builder) => ({
        getMe: builder.query({
            async onQueryStarted(_, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch {
                    const loginEndpointUrl = getAuthLoginEndpointUrl();
                    if (loginEndpointUrl) {
                        localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, window.location.href);
                        window.location.assign(loginEndpointUrl);
                    }
                }
            },
            query: () => AUTH_ME_PATH,
        }),
    }),
    reducerPath: 'authApi',
});

export const { useGetMeQuery } = authApi;
export { REDIRECT_AFTER_LOGIN_KEY };
export default authApi;
